export const disabledTooltipText = (
  <div>
    This number is already <br /> attached to this keyword
  </div>
)
